import { useMemo } from 'react';

import { PROGRAM_DURATION_WEEKS } from '../../../../config/constants';
import useDailyRegistrations from '../../../../hooks/useDailyRegistrations';

export type CtaVariant = 'welcome' | 'started' | 'finished';

const useBlockCta = () => {
  const {
    currentWeekNumber,
    registrationsToday,
  } = useDailyRegistrations();

  const variant: CtaVariant = useMemo(() => {
    if (currentWeekNumber > PROGRAM_DURATION_WEEKS) {
      return 'finished';
    }

    if (registrationsToday
      && (registrationsToday.goal === undefined
      || registrationsToday.goal === null)) {
      return 'welcome';
    }

    return 'started';
  }, [currentWeekNumber, registrationsToday && registrationsToday.goal]);

  return {
    variant,
    currentWeekNumber,
    goalToday: registrationsToday ? registrationsToday.goal : null,
  };
};

export default useBlockCta;
